const COOKIE_PREFIX = 'cmx_referral_';

/**
 * Referral scopes catalog
 */
export const REFERRAL_SCOPES = {
  USER_SIGNUP: 'user_signup',
  LOYALTY_SIGNUP: 'loyalty_signup',
  TICKETS: 'tickets',
  CANDYBAR: 'candybar',
  WALLET: 'wallet',
  PACKAGES: 'packages',
};

/**
 * Get referral code from URL query parameter
 * @returns {string|null}
 */
export const getReferralFromUrl = () => {
  const match = window.location.search.match(/[?&]ref=([^&]+)/);
  return match ? decodeURIComponent(match[1]) : null;
};

/**
 * Get referral scopes from URL query parameter
 * @returns {string[]}
 */
export const getScopesFromUrl = () => {
  const match = window.location.search.match(/[?&]ref_scope=([^&]+)/);
  if (!match) return [];
  return decodeURIComponent(match[1]).split(',');
};

/**
 * Set referral cookie for a specific scope
 * @param {string} ref - The referral code
 * @param {string} scope - The scope for this cookie
 * @param {number} expirationMinutes - Cookie expiration in minutes
 */
export const setReferralCookie = (ref, scope, expirationMinutes) => {
  if (!ref || !scope || !expirationMinutes) return;
  
  const date = new Date();
  date.setTime(date.getTime() + (expirationMinutes * 60 * 1000));
  const expires = 'expires=' + date.toUTCString();
  const cookieName = COOKIE_PREFIX + scope;
  document.cookie = cookieName + '=' + encodeURIComponent(ref) + ';' + expires + ';path=/';
};

/**
 * Get referral code for a specific scope
 * @param {string} scope - The scope to check
 * @returns {string|null}
 */
export const getReferralForScope = (scope) => {
  const cookieName = COOKIE_PREFIX + scope;
  const match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
};

/**
 * Clear a referral cookie for a specific scope
 * @param {string} scope - The scope to clear
 */
export const clearReferralCookie = (scope) => {
  const cookieName = COOKIE_PREFIX + scope;
  document.cookie = cookieName + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
};

/**
 * Add referral to params if valid for the given scope
 * @param {Object} params - Parameters of the request
 * @param {string} scope - The scope to check
 * @returns {Object} - Parameters with ref added (if applicable)
 */
export const addReferralToParams = (params, scope) => {
  const ref = getReferralForScope(scope);
  if (ref) {
    params.ref = ref;
  }
  return params;
};
